import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { getDeviationFreeDownload, getDeviationPremiumDownload } from './permissions';
/**
 * This actually covers free and tier-subscription-gated downloads
 */ export function useFreeDownloadAction(deviation, isOwner) {
    var _download;
    const { isLoggedIn } = useContext(SessionContext);
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const { isDownloadable } = useDeviationAttributes(deviation, isOwner);
    if (!isDownloadable) {
        return {
            hasAction: false
        };
    }
    if (!isLoggedIn) {
        return {
            onClick: restrictToLoggedIn(ReferralType.ACTION_BAR),
            hasAction: true
        };
    }
    const { download, permission } = getDeviationFreeDownload(deviation);
    if (permission === 'needs_subscription' || permission === 'blocked_by_subscription') {
        return {
            onClick: ()=>alert('You need to subscribe to this deviant to download this content.'),
            hasAction: true
        };
    }
    return {
        href: (_download = download) === null || _download === void 0 ? void 0 : _download.url,
        hasAction: true
    };
}
export function usePremiumDownloadAction(deviation, isOwner) {
    var _deviation_extended_pcp, _deviation_extended, _deviation_extended1, _download;
    const { isLoggedIn } = useContext(SessionContext);
    const { isPurchasable, isDownloadable } = useDeviationAttributes(deviation, isOwner);
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    if (!isDownloadable) {
        return {
            hasAction: false
        };
    }
    if (!isLoggedIn) {
        return {
            onClick: restrictToLoggedIn(ReferralType.ACTION_BAR),
            hasAction: true
        };
    }
    if (!isPurchasable) {
        return {
            hasAction: false
        };
    }
    const checkoutUrl = ((_deviation_extended_pcp = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.pcp) === null || _deviation_extended_pcp === void 0 ? void 0 : _deviation_extended_pcp.subproductId) ? Url.checkoutLink((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.pcp.subproductId) : undefined;
    const { download, permission } = getDeviationPremiumDownload(deviation, isOwner);
    return {
        href: permission === 'downloadable' ? (_download = download) === null || _download === void 0 ? void 0 : _download.url : checkoutUrl,
        hasAction: true
    };
}
